import React from "react";

export const BagIcon = () => {
  return (
    <svg
      width="27"
      height="31"
      viewBox="0 0 27 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.74039 0.421875L3.78355 4.00801L5.1441 4.75547L19.6566 5.88926L22.067 3.95762L19.3627 4.40274L20.5636 1.3877L5.74039 0.421875ZM22.0586 1.56406L23.8894 3.85684L23.058 12.4988L23.2931 22.5854L26.9548 26.2219L25.9386 21.9219L26.4005 12.44L24.2757 3.22695L22.0586 1.56406ZM21.9578 5.51973L19.0519 7.98887L5.41285 6.7543L2.61617 10.4664L1.49078 20.9309L16.0369 23.2908L1.34969 22.2494L0.738281 27.9352L17.1371 30.1775L17.8761 11.9949L21.9578 5.51973ZM22.4701 7.09863L19.3459 12.4988L18.8252 28.1115L21.8402 23.0221L21.8654 12.4988L22.4701 7.09863ZM22.7724 23.9879L18.8252 30.6814L26.6189 28.1115L22.7724 23.9879Z"
        fill="#FF5959"
      />
    </svg>
  );
};
